import React from 'react';
import { useSelector } from 'react-redux';

import {
  isAddressModalOpen,
  isCategoriesOffCanvasOpen,
  isOptinConfirmationModalOpen,
  isPharmasOffCanvasOpen,
  isSuccessModalOpen,
} from 'features/free-samples/state/opt-in-confirmation/selectors';
import {
  OptInConfirmationModal,
  PharmasOffCanvas,
  CategoryOffCanvas,
  ModalSuccess,
  AddressModal,
} from '../../components/index';

const OptInConfirmation = () => {
  const isModalActive = useSelector(isOptinConfirmationModalOpen);
  const isOffCanvasActive = useSelector(isPharmasOffCanvasOpen);
  const isSuccessModalActive = useSelector(isSuccessModalOpen);
  const isAddressModalActive = useSelector(isAddressModalOpen);
  const isCategoriesActive = useSelector(isCategoriesOffCanvasOpen);

  return (
    <>
      {isModalActive && <OptInConfirmationModal />}
      {isAddressModalActive && <AddressModal />}
      {isOffCanvasActive && <PharmasOffCanvas />}
      {isCategoriesActive && <CategoryOffCanvas />}
      {isSuccessModalActive && <ModalSuccess />}
    </>
  );
};

export default OptInConfirmation;
